export default __webpack_public_path__ + "static/media/heraldofxotli_color.229f2315.png";